import LazyLoad from 'vanilla-lazyload';
import 'photoswipe/style.css';
import PhotoSwipeLightbox from 'photoswipe/lightbox';

// One PhotoSwipe v5 instance covers every gallery on every gillamoos page.
// Each `.pswp-gallery` parent groups its `<a>` children into one swipeable
// gallery; `data-pswp-width` / `data-pswp-height` on each link are mandatory.
if (document.querySelector('.gm-page .pswp-gallery')) {
    const pswp = new PhotoSwipeLightbox({
        gallery: '.gm-page .pswp-gallery',
        children: 'a',
        pswpModule: () => import('photoswipe'),
        bgOpacity: 0.92,
        showHideAnimationType: 'fade',
        wheelToZoom: true,
        padding: { top: 24, right: 24, bottom: 24, left: 24 }
    });
    pswp.init();
}

window.radioLazyLoad = new LazyLoad({
    elements_selector: '.lazy',
    thresholds: '50%',
    use_native: true,
});

// Gillamoos 2026 Stimulus controllers — wired only on Gillamoos pages
// (the gillamoos JS bundle is the entry point for /gillamoos).
import { Application } from '@hotwired/stimulus';

import GillamoosCountdown from './controllers/gillamoos/gillamoos_countdown_controller.js';
import GillamoosHeroPreview from './controllers/gillamoos/gillamoos_hero_preview_controller.js';
import GillamoosCarousel from './controllers/gillamoos/gillamoos_carousel_controller.js';
import GillamoosHistorie from './controllers/gillamoos/gillamoos_historie_controller.js';
import GillamoosNav from './controllers/gillamoos/gillamoos_nav_controller.js';
import GillamoosCalendar from './controllers/gillamoos/gillamoos_calendar_controller.js';

if (document.querySelector('.gm-page') || document.querySelector('.gm-nav')) {
    const app = Application.start();
    app.register('gillamoos-countdown', GillamoosCountdown);
    app.register('gillamoos-hero-preview', GillamoosHeroPreview);
    app.register('gillamoos-carousel', GillamoosCarousel);
    app.register('gillamoos-historie', GillamoosHistorie);
    app.register('gillamoos-nav', GillamoosNav);
    app.register('gillamoos-calendar', GillamoosCalendar);
}

// Klaro-gated YouTube embeds + footer "Cookie-Einstellungen" link.
import { initYoutubeConsent } from './youtube-consent.js';
initYoutubeConsent();

